module.exports = __webpack_public_path__ + "static/img/c_img_3.7281568b.png";